import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const useActivityTracker = () => {
  const { token, API } = useAuth();
  const location = useLocation();
  const prevPage = useRef(null);
  const pageStart = useRef(Date.now());

  useEffect(() => {
    if (!token) return;

    const sendVisit = (page, duration) => {
      axios.post(`${API}/activity/page-visit`, { page, duration_seconds: duration }, {
        headers: { Authorization: `Bearer ${token}` },
      }).catch(() => {});
    };

    // On page change, log the previous page's duration
    if (prevPage.current && prevPage.current !== location.pathname) {
      const seconds = Math.round((Date.now() - pageStart.current) / 1000);
      if (seconds > 0) sendVisit(prevPage.current, seconds);
    }

    prevPage.current = location.pathname;
    pageStart.current = Date.now();

    // On tab close / navigate away, send final page visit via beacon
    const handleUnload = () => {
      const seconds = Math.round((Date.now() - pageStart.current) / 1000);
      if (seconds > 0 && prevPage.current) {
        const blob = new Blob(
          [JSON.stringify({ page: prevPage.current, duration_seconds: seconds, token })],
          { type: 'application/json' }
        );
        navigator.sendBeacon(`${API}/activity/page-visit-beacon`, blob);
      }
    };
    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, [location.pathname, token, API]);
};

export default useActivityTracker;
